import React, { useState, useEffect } from "react";

import PostCard from "./PostCard";

// componentの型からpostdataのみ抜き出し
type PostData = React.ComponentProps<typeof PostCard>["postdata"];
type Props = {
	postsdata: Array<PostData>;
	template_uri: string;
};
const PostsList: React.FC<Props> = (props): JSX.Element => {
	const { postsdata, template_uri } = props;
	return (
		<div className="c-goods-container">
			{postsdata.map((post) => {
				return (
					<PostCard
						postdata={post}
						key={post.id}
						template_uri={template_uri}
					/>
				);
			})}
		</div>
	);
};

export default PostsList;
